// @mui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
// theme
// routes
// hooks
// components
//

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();

  return (
    <AppBar>
      {/* <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.horizontal.H_MOBILE,
            md: HEADER.horizontal.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
        }}
      >
        <Logo />
      </Toolbar>

      <HeaderShadow /> */}
    </AppBar>
  );
}
